import React, { useMemo, useState, useEffect, createContext, useContext, cloneElement, isValidElement, createElement } from 'react';
import { CSS_VAR_RULE_MAP, fetchTokenVariable, fetchTokenValue, withUnits, themeData, BrandStore, getCssVarFromToken, hasTokens, fetchTokenFromFolder, RULE_JSON_MAP, getLayersProps, drawComponent, getLayerClass, getLayerTestId } from '@jds/layers-parser';
import { get, cloneDeep, camelCase, merge, pickBy, pascalCase } from '@jds/utils';
import { tokens } from '@jds/token-jio';
import * as CoreIcons from '@jds/core-icons';
import { createPortal } from 'react-dom';

const index$1 = '';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React$1 = React;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {
	    if (source !== undefined) {
	      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	      var lineNumber = source.lineNumber;
	      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	    }

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum(source);

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime.exports;

const EVENTS_MAP = {
  onClick: "onClick",
  onFocus: "onFocus",
  onBlur: "onBlur",
  onHover: "onMouseEnter",
  onChange: "onChange",
  onHoverEnd: "onMouseLeave",
  onKeydown: "onKeyDown",
  onKeyup: "onKeyUp",
  onInvalid: "onInvalid",
  onLoad: "onLoad",
  onError: "onError",
  onPaste: "onPaste",
  onScroll: "onScroll",
  onSwipeLeft: [
    "onPointerDown",
    "onPointerMove",
    "onPointerUp",
    "onPointerOut",
    "onDragStart",
    "onDragEnd"
  ]
};
const filterInvalidValue = (v) => {
  if (typeof v === "undefined")
    return false;
  if (v === "")
    return false;
  if (v === null)
    return false;
  return true;
};
function getEventName(key) {
  const match = Object.keys(EVENTS_MAP).find((evt) => key === evt);
  const matchedEvent = EVENTS_MAP[match];
  return matchedEvent;
}
const internalLayerPrefixes = ["jds", "tooltip"];
const processConfigAPI = (config, values, layerProps) => {
  if (!values)
    return {};
  const finalData = {};
  Object.entries(config || {}).forEach(([name, item]) => {
    const resolvedConfigValues = item.values || [];
    if (!layerProps?.[name]) {
      if (!resolvedConfigValues.includes(values[name])) {
        if (filterInvalidValue(resolvedConfigValues[0]))
          finalData[name] = resolvedConfigValues[0];
      } else {
        if (filterInvalidValue(values[name]))
          finalData[name] = values[name];
      }
    }
  });
  return finalData;
};
const acceptedInternalProps = [
  "internalIndex",
  "layerRefs",
  "className",
  "internalClasses"
];
const processDataAPI = (api, currentLayer, values) => {
  if (!currentLayer)
    return {};
  const processData = {};
  const processedEvents = {};
  let processedA11y = {};
  const { data = {}, events, children = {} } = api;
  const currentDataItem = data[currentLayer];
  Object.entries(currentDataItem || {}).forEach(
    ([name, { name: propName = "" }]) => {
      const currentName = propName.slice(
        propName.lastIndexOf(".") + 1,
        propName.length
      );
      const value = get(values, propName, void 0) || get(values, currentName, void 0);
      if (typeof value !== "undefined")
        processData[name] = value;
    }
  );
  if (events) {
    const currentEventItem = events[currentLayer];
    if (currentEventItem) {
      Object.entries(currentEventItem).forEach(([internalName, valueName]) => {
        const eventMapItem = getEventName(internalName);
        const resolvedName = typeof valueName === "string" ? valueName : valueName.name;
        if (!Array.isArray(eventMapItem)) {
          processedEvents[eventMapItem || internalName] = values[resolvedName] || values[eventMapItem];
        } else {
          eventMapItem.forEach((item) => {
            processedEvents[item] = values[item];
          });
          processedEvents[internalName] = values[resolvedName];
        }
      });
    }
  }
  if (api.a11y) {
    processedA11y = processA11yData(api.a11y, currentLayer, values);
  }
  acceptedInternalProps.map((item) => {
    if (item in values)
      processData[item] = values[item];
  });
  return {
    processData,
    processedEvents,
    processedA11y,
    processedChildren: children
  };
};
const processA11yData = (data, layer, api) => {
  if (!data[layer])
    return {};
  const { properties } = data[layer];
  if (!properties)
    return {};
  const processed = {};
  Object.entries(properties).forEach(([internalProperty, property]) => {
    if (typeof property === "string") {
      const normalisedProperty = property.slice(
        property.lastIndexOf(".") + 1,
        property.length
      );
      processed[internalProperty] = api[normalisedProperty];
    } else {
      const { name, value, prop } = property;
      const normalisedName = name?.slice(
        name.lastIndexOf(".") + 1,
        name.length
      );
      const defaultValue = api[prop || ""] || value;
      processed[internalProperty] = api[normalisedName] || defaultValue;
    }
  });
  return processed;
};
const validateProp = (prop) => {
  if (typeof prop === "undefined")
    return false;
  if (prop === null)
    return false;
  if (prop === "")
    return false;
  return true;
};
const mergeStyleProperties = (props, uiTokens, data, layerProps) => {
  const modifiedStyles = cloneDeep(uiTokens);
  Object.entries(data || {}).forEach(([layer, properties]) => {
    Object.entries(properties).forEach(([internalName, { name }]) => {
      modifiedStyles[layer] = modifiedStyles[layer] || {};
      if (validateProp(props[name])) {
        if (name in CSS_VAR_RULE_MAP) {
          if (!layerProps[layer] || !(name in layerProps[layer])) {
            modifiedStyles[layer][name] = props[name];
          } else {
            delete modifiedStyles[layer][name];
          }
        } else {
          delete modifiedStyles[layer][name];
        }
        if (internalName in CSS_VAR_RULE_MAP) {
          if (!layerProps[layer] || !(internalName in layerProps[layer])) {
            modifiedStyles[layer][internalName] = props[name];
          } else {
            delete modifiedStyles[layer][internalName];
          }
        } else {
          delete modifiedStyles[layer][internalName];
        }
      }
    });
  });
  return modifiedStyles;
};
const allowedLayerProps = ["disabled", "transition"];
const seperateComponentLayerProps = (styles = {}) => {
  const layerProps = {};
  Object.entries(styles).forEach(([currentlayer, currentStyles]) => {
    const layerElements = currentlayer.split("-");
    const layerName = layerElements[layerElements.length - 1];
    if (!layerProps[currentlayer]) {
      layerProps[currentlayer] = {};
    }
    const isInternalLayer = internalLayerPrefixes.find(
      (i) => layerName.startsWith(i)
    );
    if (isInternalLayer) {
      Object.entries(currentStyles || {}).forEach(([property, value]) => {
        layerProps[currentlayer][property] = value;
      });
    }
    if (styles.value) {
      layerProps[currentlayer].value = currentStyles.value;
    }
    Object.entries(currentStyles).forEach(([property, value]) => {
      if (!(property in CSS_VAR_RULE_MAP)) {
        if (!(currentlayer in layerProps)) {
          layerProps[currentlayer] = {};
        }
        layerProps[currentlayer][property] = value;
      } else {
        if (allowedLayerProps.includes(property)) {
          layerProps[currentlayer][property] = value;
        }
      }
    });
  });
  return { layerProps, styles };
};
const tokenKeys = ["mode", "theme"];
function getRoot(hierarchy) {
  const root = hierarchy;
  if (typeof root === "object") {
    return Object.keys(root)[0];
  }
  return "";
}
function getSubLayers(hierarchy, layer) {
  const layerHierarchy = findHierarchy(hierarchy, layer);
  return layerHierarchy ? layerHierarchy[layer]?.flatMap((subLayer) => {
    if (typeof subLayer === "string") {
      return subLayer;
    }
    const root = getRoot(subLayer);
    return [root].concat(getSubLayers(subLayer, root) ?? []);
  }) ?? void 0 : void 0;
}
function findHierarchy(hierarchy, layer) {
  if (hierarchy[layer]) {
    return hierarchy;
  }
  const root = getRoot(hierarchy);
  const subLayers = hierarchy[root];
  for (const subLayer of subLayers ?? []) {
    if (typeof subLayer === "string") {
      if (subLayer === layer) {
        return null;
      }
    } else {
      const subHierarchy = findHierarchy(subLayer, layer);
      if (subHierarchy) {
        return subHierarchy;
      }
    }
  }
  return null;
}
const updateLayersWithParentTokens = (tokens, styles, hierarchy) => {
  const modifiedTokens = { ...tokens };
  const modifiedBase = { ...styles };
  for (const key in styles) {
    const styleKeys = Object.keys(styles[key]);
    for (const styleKey of styleKeys) {
      if (tokenKeys.includes(styleKey)) {
        modifiedTokens[styleKey] = styles[key][styleKey];
        const children = getSubLayers(hierarchy, key);
        if (children) {
          children.forEach((child) => {
            if (child in styles)
              modifiedBase[child][styleKey] = styles[key]?.[styleKey];
          });
        }
      }
    }
  }
  return { modifiedBase, modifiedTokens };
};
const BufferConverter = (value) => {
  return Buffer.from(value, "base64").toString("utf-8");
};
const convertBase64ToObject = (value) => {
  if (!value)
    return {};
  const converter = typeof window === "undefined" ? BufferConverter : window.atob;
  const objectString = converter(value);
  return JSON.parse(objectString || "{}");
};
const getCustomJSON = (custom) => {
  const base64 = (custom?.split("--") || [])[1];
  const convertedCustom = convertBase64ToObject(base64);
  return convertedCustom;
};
const getBaseLayerName = (layer = "") => {
  const parts = layer.split("-");
  return parts[parts.length - 1];
};
const STYLE_ALLOWED_COMPONENTS = ["JDSContainer"];
const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

const AnimatedContainer = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: [props.className, "progress-animateContainer"].join(" ")
    }
  );
};

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}
function describeArc(x, y, radius, startAngle, endAngle) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  const d = [
    "M",
    start.x,
    start.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y
  ].join(" ");
  return d;
}
function getColorVariable(val) {
  if (typeof val === "string") {
    if (val.match(/[{}]/)) {
      return fetchTokenVariable("color", val);
    }
  }
  return val.toString();
}
function getValue(val, rule, tokens = {}) {
  if (typeof val === "string") {
    if (val.match(/[{}]/)) {
      return fetchTokenValue(rule, val, tokens);
    }
  }
  return withUnits(rule, val);
}
const Arc = ({
  radius = 0,
  start = 0,
  end = 0,
  fill,
  className,
  arcWidth = 10,
  "animation-delay": animationDelay = "0ms",
  layer,
  animate,
  ...rest
}) => {
  start = parseInt(getValue(start, "rotate"), 10);
  end = parseInt(getValue(end, "rotate"), 10);
  radius = parseInt(getValue(radius, "width"), 10);
  arcWidth = parseInt(getValue(arcWidth, "width"), 10);
  animationDelay = getValue(animationDelay, "transition-delay");
  const strokeWidth = end - start === 0 ? 0 : arcWidth / 2;
  const diameter = radius * 2;
  const halfRadius = radius / 2;
  const circumference = 2 * Math.PI * halfRadius;
  const percent = end / 360 * 100;
  const dash = percent * circumference / 100;
  const midRadius = radius + strokeWidth;
  const variables = {
    "--diameter": diameter,
    "--rotate": `-${end}deg`,
    "--fill-color": getColorVariable(fill || "currentcolor"),
    "--animation-delay": parseInt(rest["animation-delay"]) / 1e3 + "s",
    "--offset": animate ? "100px" : `${dash}px ${circumference - dash}px`,
    "--end": end * Math.PI / 180,
    "--start": start * Math.PI / 180
  };
  const animateClass = animate ? "jds-spinner-circle-animate" : "";
  const arc = useMemo(() => {
    return describeArc(midRadius / 2, midRadius / 2, radius / 2, start, end);
  }, [start, end, midRadius]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: [className, animateClass].join(" "),
      style: {
        width: diameter,
        height: diameter,
        ...variables
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "svg",
        {
          className: [
            "jds-spinner-circle",
            `circle-${layer}`,
            animate ? "animate" : ""
          ].join(" "),
          viewBox: `0 0 ${radius + arcWidth / 2} ${radius + arcWidth / 2}`,
          children: Math.abs(end - start) === 360 || animate ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            "circle",
            {
              fill: "none",
              stroke: variables["--fill-color"],
              r: halfRadius,
              cx: midRadius / 2,
              cy: midRadius / 2,
              strokeWidth,
              strokeLinecap: "round"
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: arc,
              strokeLinecap: "round",
              className: [animate ? "animated" : ""].join(" "),
              strokeWidth,
              stroke: variables["--fill-color"],
              fill: "none",
              "data-dimension": `${end}-${start}-${end - start}`
            }
          )
        }
      )
    }
  );
};

const index = '';

const ButtonVector = (props) => {
  const transformAngle = props.direction !== "reversed" ? 180 : 0;
  const borderClass = props["border-type"] === "solid" ? "solid-border" : "none";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      className: [props.className, borderClass, "sw-btn-vector"].join(" "),
      style: {
        ...props.style,
        transform: `rotate(${transformAngle}deg)`
      },
      preserveAspectRatio: "none",
      viewBox: "0 0 40 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("mask", { id: "path-1-inside-1_23_23", fill: "red", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            className: "inside",
            d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M12.53 56V57H12.5381L12.5463 56.9999L12.53 56ZM28.54 41.98L27.5923 41.6608L27.5891 41.6704L27.5861 41.68L28.54 41.98ZM40 28L40.1614 28.9869L40.1659 27.0139L40 28ZM28.54 14.02L27.5861 14.32L27.5892 14.33L27.5926 14.3399L28.54 14.02ZM12.53 0L12.5463 -0.999867L12.5381 -1H12.53V0ZM0 57H12.53V55H0V57ZM12.53 56C12.5463 56.9999 12.5469 56.9999 12.5476 56.9998C12.5479 56.9998 12.5486 56.9998 12.5491 56.9998C12.5503 56.9998 12.5516 56.9998 12.5531 56.9997C12.556 56.9997 12.5597 56.9996 12.5641 56.9995C12.5729 56.9993 12.5844 56.9989 12.5988 56.9984C12.6274 56.9974 12.6671 56.9957 12.7171 56.993C12.8171 56.9875 12.9588 56.9776 13.1374 56.96C13.4946 56.9249 14.0005 56.8588 14.6173 56.7345C15.8497 56.4863 17.5338 56.004 19.3606 55.0658C23.038 53.1773 27.2325 49.47 29.4939 42.28L27.5861 41.68C25.4975 48.32 21.687 51.6227 18.4469 53.2867C16.815 54.1248 15.3121 54.5544 14.2224 54.7739C13.6781 54.8836 13.2391 54.9404 12.9416 54.9696C12.7929 54.9843 12.6799 54.992 12.6069 54.996C12.5705 54.998 12.5441 54.9991 12.5284 54.9997C12.5205 54.9999 12.5153 55.0001 12.5128 55.0001C12.5116 55.0002 12.5111 55.0002 12.5112 55.0002C12.5113 55.0002 12.5115 55.0002 12.5119 55.0002C12.5121 55.0002 12.5126 55.0002 12.5127 55.0001C12.5132 55.0001 12.5137 55.0001 12.53 56ZM29.4877 42.2992C33.2983 30.9845 38.4683 29.2638 40.1614 28.9869L39.8386 27.0131C37.2517 27.4362 31.5817 29.8155 27.5923 41.6608L29.4877 42.2992ZM40.1659 27.0139C38.4677 26.7282 33.3074 25.0135 29.4874 13.7001L27.5926 14.3399C31.5926 26.1865 37.2523 28.5518 39.8341 28.9861L40.1659 27.0139ZM29.4939 13.72C27.2325 6.53004 23.038 2.82274 19.3606 0.934197C17.5338 -0.00395302 15.8497 -0.486254 14.6173 -0.734524C14.0005 -0.858788 13.4946 -0.924878 13.1374 -0.960018C12.9588 -0.977597 12.8171 -0.987457 12.7171 -0.992973C12.6671 -0.995731 12.6274 -0.997405 12.5988 -0.998413C12.5844 -0.998918 12.5729 -0.999256 12.5641 -0.999481C12.5597 -0.999594 12.556 -0.999678 12.5531 -0.99974C12.5516 -0.999771 12.5503 -0.999796 12.5491 -0.999817C12.5486 -0.999828 12.5479 -0.999841 12.5476 -0.999846C12.5469 -0.999857 12.5463 -0.999867 12.53 0C12.5137 0.999867 12.5132 0.999858 12.5127 0.99985C12.5126 0.999848 12.5121 0.99984 12.5119 0.999836C12.5115 0.999829 12.5113 0.999824 12.5112 0.999822C12.5111 0.999819 12.5116 0.99983 12.5128 0.999862C12.5153 0.999925 12.5205 1.00007 12.5284 1.00035C12.5441 1.0009 12.5705 1.00198 12.6069 1.00399C12.6799 1.00801 12.7929 1.01574 12.9416 1.03037C13.2391 1.05964 13.6781 1.11644 14.2224 1.22609C15.3121 1.44563 16.815 1.8752 18.4469 2.7133C21.687 4.37726 25.4975 7.67996 27.5861 14.32L29.4939 13.72ZM12.53 -1H0V1H12.53V-1Z",
            fill: "url(#paint0_angular_23_23)",
            mask: "url(#path-1-inside-1_23_23)"
          }
        ),
        props["border-type"] === "gradient" && /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "radialGradient",
          {
            id: "paint0_angular_23_23",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(38.5 51.5) rotate(154.464) scale(70.402 85.8467)",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.0165174", stopColor: "#EAB872" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.280935", stopColor: "#63371D" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.563131", stopColor: "#FFEAC2" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.796371", stopColor: "#AE824E" })
            ]
          }
        ) })
      ]
    }
  );
};

const WINDOW = typeof window === "object" && window || void 0;
const defaultBreakpoints = {
  xmobile: 323,
  mobile: 619,
  tablet: 991,
  desktop: 992,
  widescreen: 1280,
  hd: 1920
};
class Devices {
  static withSizes(breakpoints) {
    this.breakpoints = Object.assign(this.breakpoints, breakpoints);
    return this;
  }
  /**
   * is width xmobile and below
   */
  static isXMobile() {
    const width = WINDOW?.innerWidth || 1e3;
    return width <= this.breakpoints.xmobile;
  }
  /**
   * is width mobile and below. returns true even on xmobile
   */
  static isMobile() {
    const width = WINDOW?.innerWidth || 1e3;
    return width <= this.breakpoints.mobile;
  }
  /**
   * is width above mobile and below desktop
   */
  static isTabletOnly() {
    const width = WINDOW?.innerWidth || 1e3;
    return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
  }
  /**
   * is width less than tablet? returns true even on mobile and xmobile
   */
  static isTablet() {
    const width = WINDOW?.innerWidth || 1e3;
    return width <= this.breakpoints.tablet;
  }
  /**
   * is width greater than tablet?
   */
  static isDesktop() {
    const width = WINDOW?.innerWidth || 1e3;
    return width >= this.breakpoints.tablet;
  }
  /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */
  static isWidescreen() {
    const width = WINDOW?.innerWidth || 0;
    return width >= this.breakpoints.widescreen;
  }
  /**
   * is width greater than or equal to HD.
   */
  static isHD() {
    const width = WINDOW?.innerWidth || 0;
    return width >= this.breakpoints.hd;
  }
  /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */
  static useMedia() {
    const queries = [
      `(max-width: ${this.breakpoints.xmobile}px)`,
      `(max-width: ${this.breakpoints.mobile}px)`,
      `(max-width: ${this.breakpoints.tablet}px)`,
      `(min-width: ${this.breakpoints.desktop}px)`,
      `(min-width: ${this.breakpoints.widescreen}px)`,
      `(min-width: ${this.breakpoints.hd}px)`
    ];
    const mediaQueryLists = queries.map(
      (q) => WINDOW?.matchMedia && WINDOW.matchMedia(q)
    );
    const getValue = () => {
      const matchedResults = mediaQueryLists.map((mql) => mql?.matches);
      const valObj = {
        xmobile: false,
        mobile: false,
        tablet: false,
        desktop: false,
        widescreen: false,
        hd: false
      };
      Object.keys(this.breakpoints).forEach((key, i) => {
        valObj[key] = matchedResults[i];
      });
      return valObj;
    };
    const [value, setValue] = useState(getValue);
    useEffect(
      () => {
        const handler = () => setValue(getValue);
        mediaQueryLists.forEach((mql) => mql?.addListener(handler));
        return () => mediaQueryLists.forEach((mql) => mql?.removeListener(handler));
      },
      []
      // Empty array ensures effect is only run on mount and unmount
    );
    return value;
  }
}
Devices.breakpoints = defaultBreakpoints;

const getThemeColors = (theme) => {
  const currentTheme = themeData.find(
    (data) => camelCase(theme) === camelCase(data.name)
  );
  if (currentTheme) {
    const { primaryColor, secondaryColor, sparkleColor } = currentTheme;
    return {
      primary: primaryColor,
      secondary: secondaryColor,
      sparkle: sparkleColor
    };
  }
  return {
    primary: themeData[0].primaryColor,
    secondary: themeData[0].secondaryColor,
    sparkle: themeData[0].sparkleColor
  };
};

function getMatchingRule(folderKey) {
  const ruleMap = RULE_JSON_MAP;
  const [rule] = Object.entries(ruleMap).find(
    ([_, valueSet]) => valueSet.includes(folderKey)
  ) || [];
  return rule || folderKey;
}
const resolvePlatform = () => {
  const platform = Devices.useMedia();
  if (platform.desktop || platform.widescreen || platform.hd)
    return "desktop";
  return "mobile";
};
const defaultTokenValues = {
  theme: "jio-base",
  mode: "light",
  surface: "bold",
  emphasis: "primary",
  "surface-type": "default",
  density: "cozy",
  lang: "en",
  platform: "desktop",
  appearance: "primary"
};
const getMergedTokens = (value = {}) => {
  return merge(
    {},
    defaultTokenValues,
    getThemeColors(value?.theme || defaultTokenValues.theme),
    value
  );
};
const themeKeys = ["primary", "secondary", "sparkle", "theme", "mode"];
const TokenContext = createContext({});
const registerBrandAndFetchTokenVars = (value, existingTokens, brandTokens) => {
  const tokens$1 = getMergedTokens({ ...existingTokens, ...value || {} });
  if (!tokens$1.registered || brandTokens) {
    BrandStore.registerBrand(brandTokens || tokens);
    tokens$1.registered = true;
  }
  const equalThemeTokens = themeKeys.every(
    (key) => existingTokens[key] === value[key] || !(key in value)
  );
  const styles = equalThemeTokens && !(value.source === "popup") ? {} : Object.fromEntries(
    Object.entries(BrandStore.getApplicableTokens(tokens$1)).flatMap(
      ([folderKey, folder]) => Object.entries(folder).map(([key, value2]) => [
        getCssVarFromToken(`${folderKey}-${key}`),
        hasTokens(value2) ? fetchTokenFromFolder(
          getMatchingRule(folderKey),
          value2,
          tokens$1
        ) : withUnits(folderKey, value2)
      ])
    )
  );
  return { styles, tokens: tokens$1 };
};
const TokenProvider = ({
  value = defaultTokenValues,
  children,
  tokens: brandTokens
}) => {
  const existingTokens = useContext(TokenContext) || {};
  const { styles, tokens } = useMemo(
    () => registerBrandAndFetchTokenVars(value, existingTokens, brandTokens),
    [value, brandTokens]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...styles, display: "contents" }, className: "tokens", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TokenContext.Provider, { value: { ...tokens, platform: resolvePlatform() }, children }) });
};
function useTokenValues() {
  const tokenValues = useContext(TokenContext);
  if (tokenValues === void 0) {
    throw new Error("useTokenValues must be used within a TokenProvider");
  }
  return tokenValues;
}
const useToken = (value, type) => {
  const tokens = useContext(TokenContext);
  if (tokens === void 0) {
    throw new Error("Please wrap your app in a TokenProvider");
  }
  return fetchTokenValue(type, value, tokens);
};

const unsafeProps = [
  "height",
  "padding",
  "opacity",
  "translate-y",
  "translate-x",
  "max-height"
];
const Animated = (props) => {
  const [internalHidden, setInternalHidden] = useState(
    !props.animatedProperties?.length
  );
  useEffect(() => {
    if (!props.hidden) {
      setInternalHidden(false);
    }
  }, [props.hidden]);
  const hasProperties = unsafeProps.some(
    (property) => props.animatedProperties?.includes(property)
  );
  if (props.hidden) {
    if (!props.animatedProperties?.length)
      return null;
    if (!internalHidden) {
      if (!hasProperties)
        return null;
      return props.children;
    }
    if (hasProperties)
      return props.children;
    return null;
  }
  return React.cloneElement(props.children, {
    onTransitionEnd: (ev) => {
      if (props.hidden) {
        setInternalHidden(true);
      }
    }
  });
};

const resolveDisabled = (disabled) => {
  if (typeof disabled === "object")
    return false;
  return disabled;
};
const disabledStyles = {
  cursor: "not-allowed",
  pointerEvents: "none",
  userSelect: "none"
};
const Component = (props) => {
  const {
    children,
    elementRef,
    events = {},
    className,
    style,
    disabled,
    passive,
    layer = "",
    target,
    href,
    title,
    internalIndex,
    root,
    rootRef,
    show,
    ...rest
  } = props;
  const isButton = className.includes("j-JDSButton-container");
  const Element = isButton ? "button" : "div";
  if (!show && (!children || Array.isArray(children) && children.every((c) => c === null))) {
    return null;
  }
  const resolvedDisabled = resolveDisabled(disabled);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Animated,
    {
      hidden: [true, "true"].includes(props.hidden),
      animatedProperties: rest.transition?.property,
      children: React.createElement(
        Element,
        {
          ...events,
          type: rest.type,
          id: layer + (internalIndex || ""),
          "data-testid": rest?.["data-testid"],
          className,
          ref: elementRef || rootRef,
          disabled: resolvedDisabled,
          onKeyDown: (ev) => {
            if (document.activeElement === ev.target) {
              if (ev.key === "Enter") {
                const event = new MouseEvent("click", {
                  bubbles: true,
                  cancelable: true
                });
                ev.target.dispatchEvent(event);
              }
            }
            props.onKeyDown?.(ev);
          },
          title,
          style: {
            ...style,
            touchAction: passive ? "none" : void 0,
            ...resolvedDisabled ? disabledStyles : { cursor: events.onClick ? "pointer" : void 0 }
          },
          tabIndex: disabled ? -1 : events.onClick ? 0 : void 0,
          "aria-label": props["aria-label"],
          "aria-labelledby": props["aria-labelledby"],
          "aria-describedby": props["aria-describedby"],
          "aria-disabled": props.disabled === true ? "true" : "false",
          role: props.role,
          "aria-checked": props["aria-checked"],
          "aria-orientation": props["aria-orientation"],
          "aria-current": props["aria-current"],
          "aria-expanded": props["aria-expanded"],
          "aria-controls": props["aria-controls"],
          "aria-valuemin": props["aria-valuemin"],
          "aria-valuemax": props["aria-valuemax"],
          "aria-valuenow": props["aria-valuenow"],
          "aria-busy": props["aria-busy"],
          "aria-valuetext": props["aria-valuetext"],
          "aria-selected": props["aria-selected"],
          "aria-pressed": props["aria-pressed"],
          "aria-hidden": props["aria-hidden"],
          "aria-modal": props["aria-modal"],
          "aria-haspopup": props["aria-haspopup"],
          "aria-live": props["aria-live"]
        },
        children
      )
    }
  );
};
const Container = (props) => {
  const newTokens = pickBy(props, (v, k) => {
    return tokenKeys.includes(k);
  });
  const currentTokens = useTokenValues();
  if (Object.keys(newTokens || {}).length) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TokenProvider, { value: { ...currentTokens, ...newTokens }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props });
};

const registeredIcons = { ...CoreIcons };
const registerIcons = (icons) => {
  Object.assign(registeredIcons, icons);
};
const availableIcons = (icons) => Object.keys(icons).filter((icon) => typeof icons[icon] === "function");
const useIcons = (ic) => {
  const [icon, setIcon] = useState(null);
  useEffect(() => {
    if (typeof ic === "string" && availableIcons(registeredIcons).includes(ic)) {
      setIcon(registeredIcons[ic]);
    } else if (typeof ic === "object") {
      setIcon(ic);
    }
  }, [ic]);
  return icon;
};

const Icon = ({
  value,
  events,
  style,
  layer,
  className,
  role,
  "aria-label": ariaLabel,
  "aria-describedby": ariaDescribedby,
  ...rest
}) => {
  const stringIcon = typeof value === "string";
  const camelCaseIcon = !stringIcon ? value : pascalCase(value || "", "_");
  const icon = useIcons(camelCaseIcon);
  if (stringIcon) {
    if (!value)
      return null;
  }
  if (!stringIcon && !value)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Animated,
    {
      hidden: [true, "true"].includes(rest.hidden),
      animatedProperties: rest.transition?.property,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          "data-testid": rest?.["data-testid"] || "icon-root",
          className: ["icon-atom", className].join(" "),
          id: layer,
          ...events,
          style,
          "data-hidden": rest.hidden,
          "data-transition": Boolean(rest.transition),
          role,
          "aria-label": ariaLabel,
          "aria-describedby": ariaDescribedby,
          children: icon
        }
      )
    }
  );
};

const Image = (props) => {
  const { value, semantics, events, ...props_ } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      "data-testid": "image-root",
      alt: semantics || value,
      src: value,
      ...props_,
      ...events,
      style: {
        ...props_.style,
        width: "100%",
        opacity: !value ? 0 : void 0
      }
    }
  );
};

const Input = (props) => {
  const {
    disabled,
    className,
    children,
    type,
    internalIndex,
    root,
    rootRef,
    textAlign,
    events = {},
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedby,
    "aria-invalid": ariaInvalid,
    "aria-required": _ariaRequired,
    "aria-placeholder": _ariaPlaceholder,
    ...rest
  } = props;
  const combinedStyles = {
    ...rest?.style,
    textAlign
  };
  const commonProps = {
    ...events,
    ...rest,
    style: combinedStyles,
    disabled,
    maxLength: rest["max-length"],
    defaultValue: events.onChange ? void 0 : rest.value,
    value: events.onChange ? rest.value : void 0
  };
  switch (type.toLowerCase()) {
    case "textarea":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-area-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "textarea",
        {
          ref: rest.layerRefs?.[rest.layer],
          ...commonProps,
          className: ["jds-input-atom", className, "jds-textarea-atom"].join(
            " "
          ),
          "aria-label": ariaLabel,
          "aria-describedby": ariaDescribedby,
          "aria-invalid": ariaInvalid,
          "aria-required": _ariaRequired,
          "aria-placeholder": _ariaPlaceholder
        }
      ) });
    case "phone":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ...commonProps,
          ref: rest.layerRefs?.[rest.layer],
          type: "tel",
          className: ["jds-input-atom", className].join(" ")
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ...commonProps,
          type,
          ref: rest.layerRefs?.[rest.layer],
          className: ["jds-input-atom", className].join(" "),
          "aria-label": ariaLabel,
          "aria-describedby": ariaDescribedby,
          "aria-invalid": ariaInvalid,
          "aria-required": _ariaRequired,
          "aria-placeholder": _ariaPlaceholder
        }
      );
  }
};

const Link = (props) => {
  const { children, events, className, style, layer, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "a",
    {
      ...events,
      className,
      style,
      "data-testid": rest?.["data-testid"],
      children: React.Children.map(props.children, (item) => item && cloneElement(item))
    }
  );
};

const Loader = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "loader-root", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}) });
};
const Spinner = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "j-spinner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: "circle circle-0", viewBox: "0 0 28 28", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "circle",
      {
        "data-testid": "spinner-circle-icon",
        fill: "none",
        strokeWidth: "4",
        strokeLinecap: "round",
        cx: "14",
        cy: "14",
        r: "12"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: "circle circle-1", viewBox: "0 0 28 28", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "circle",
      {
        "data-testid": "spinner-circle-icon",
        fill: "none",
        strokeWidth: "4",
        strokeLinecap: "round",
        cx: "14",
        cy: "14",
        r: "12"
      }
    ) })
  ] });
};

function CustomPortal({ children }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted && typeof window !== "undefined" ? createPortal(children, document.body) : null;
}

const Popup = ({
  children,
  className,
  style,
  events,
  rootRef,
  layer,
  ...rest
}) => {
  const { alignment = "top-start", priority } = rest;
  const x = rest.offsetX;
  const y = rest.offsetY;
  const left = alignment.includes("start") && x ? `${x}px` : void 0;
  const right = alignment.includes("end") && x ? `${x}px` : void 0;
  const top = alignment.includes("top") && y ? `${y}px` : void 0;
  const bottom = alignment.includes("bottom") && y ? `${y}px` : void 0;
  const styles = {
    backgroundColor: rest["background-color"],
    pointerEvents: rest.passive ? "none" : "auto",
    "--popup-priority": priority,
    "--popup-left": left,
    "--popup-right": right,
    "--popup-top": top,
    "--popup-bottom": bottom
  };
  const tokens = useTokenValues();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CustomPortal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TokenProvider, { value: { ...tokens, source: "popup" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Animated,
    {
      hidden: rest.hidden,
      animatedProperties: rest.transition?.property,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          id: layer,
          ref: rootRef,
          style: {
            ...styles,
            ...style,
            pointerEvents: !rest.passive ? "auto" : "none",
            touchAction: events?.onClick || !rest.passive ? "auto" : "none"
          },
          className: ["jds-popup-layer", className].join(" "),
          ...events,
          onClick: (ev) => {
            if (events?.onClick)
              ev.stopPropagation();
            events?.onClick?.(ev);
          },
          children
        }
      )
    }
  ) }) });
};

const PromoCardArc = (props) => {
  const { orientation, style, className } = props;
  if (orientation === "horizontal") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "svg",
      {
        className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: { display: "block", ...style },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0,0 L0,5 C1,3 1,-3 0,-5 L0,0", fill: "currentcolor" })
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      className,
      viewBox: "0 0 1 1",
      xmlns: "http://www.w3.org/2000/svg",
      style: { display: "block", ...style },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M0,0 L0,10 C1,3 1,-3 0,-10 L0,0",
          fill: "currentcolor",
          style: {
            transform: "rotate(270deg) translateX(-100%) translateY(50%"
          }
        }
      )
    }
  );
};

const SkeletonAnimatedLayer = ({
  layer,
  style,
  className
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: ["skeleton-animate-loader-container", className].join(" "), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: layer, style }) });
};

const getTokenValue = (type, tokens, value) => {
  if (!value)
    return "";
  return fetchTokenVariable(type, value.toString() || "");
};
function getProgress(value = 0, min = 0, max = 100) {
  const offset = value - min;
  const range = max - min;
  const ratio = offset / range;
  const percentage = (1 - ratio) * 100;
  return Math.round(percentage);
}
function getSteppedValue(value, step = 1, min = 0, max = 100) {
  if (typeof value !== "number") {
    return min;
  }
  step = step > 0 ? step : 1;
  const clamped = clamp(value, min, max);
  return Math.round((clamped - min) / step) * step + min;
}
const Slider = ({
  min = 0,
  max = 100,
  "aria-label": ariaLabel,
  "aria-describedby": ariaDescribedby,
  "aria-valuenow": _ariaValuenow,
  "aria-valuemin": _ariaValuemin,
  "aria-valuemax": _ariaValuemax,
  ...props
}) => {
  const tokens = useTokenValues();
  const ballProperties = {
    "--ball-color": getTokenValue("color", tokens, props["ball-color"]),
    "--ball-color--active": getTokenValue(
      "color",
      tokens,
      props.style?.behavior.active["ball-color-active"]
    ),
    "--ball-color--hover": getTokenValue(
      "color",
      tokens,
      props.style?.behavior.hover["ball-color-active"]
    ),
    "--ball-size": getTokenValue("width", tokens, props["ball-size"]),
    "--ball-border-width": getTokenValue(
      "width",
      tokens,
      props["ball-border-width"]
    ),
    "--ball-border-color": getTokenValue(
      "color",
      tokens,
      props["ball-border-color"]
    ),
    "--active-color": getTokenValue("color", tokens, props["active-color"]),
    "--active-color--active": getTokenValue(
      "color",
      tokens,
      props.style?.behavior.active["active-color-active"]
    ),
    "--inactive-color": getTokenValue("color", tokens, props["inactive-color"])
  };
  const requiredValue = getSteppedValue(props.value, props.step, min, max) || 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      type: "range",
      step: props.step,
      value: requiredValue,
      min,
      max,
      size: 2,
      onChange: props.onChange,
      className: [props.className, "jds-slider-atom"].join(" "),
      "aria-label": ariaLabel,
      "aria-describedby": ariaDescribedby,
      "aria-valuenow": _ariaValuenow,
      "aria-valuemin": _ariaValuemin,
      "aria-valuemax": _ariaValuemax,
      style: {
        ...props.style,
        ...ballProperties,
        height: getTokenValue("height", tokens, props["track-height"]),
        "--progress": `${getProgress(requiredValue, min, max)}%`
      }
    }
  );
};

const RenderComponent = (Comp, props) => {
  if (Array.isArray(Comp)) {
    return Comp.map((C) => RenderComponent(C, props));
  }
  if (!isValidElement(Comp)) {
    return null;
  }
  const compName = getComponentName(Comp);
  const { slot_layers, ...newProps } = props ?? {};
  const { lock_all, ...slotProps } = slot_layers?.[compName] ?? {};
  for (const prop in slotProps) {
    const arr = [].concat(slotProps[prop]);
    const value = Comp.props[prop];
    if (arr.includes(value)) {
      newProps[prop] = value;
    } else {
      newProps[prop] = arr[0];
      value !== void 0 && console.warn(
        `Invalid property on ${compName} for ${prop} - currently ${value}. Value must be one of [${arr.join()}]`
      );
    }
  }
  if (lock_all) {
    return createElement(Comp.type, newProps);
  }
  return cloneElement(Comp, newProps);
};
const removeBrandPrefixes = (name) => {
  const PREFIXES = ["jds_"];
  let currentName = name;
  PREFIXES.forEach((prefix) => {
    currentName = currentName.replace(prefix, "");
  });
  return currentName;
};
const getComponentName = (Comp) => {
  if (!Comp)
    return "";
  if (Comp?.type?.slotName)
    return Comp?.type?.slotName;
  return Comp?.type?.displayName;
};
const Slot = ({
  _childrenProps,
  layer,
  events,
  className,
  style = {},
  disabled,
  slot_layers,
  ...rest
}) => {
  const { api: children, props } = _childrenProps;
  if (!children?.[layer]?.name)
    return null;
  const Comp = props?.[children?.[layer]?.name];
  if (!Comp)
    return null;
  const hasStyle = Boolean(Object.keys(style || {}).length);
  const _accepts = children?.[layer]?.accepts;
  const acceptedArrayItems = [];
  _accepts?.forEach((item) => {
    if (typeof item === "string") {
      acceptedArrayItems.push(removeBrandPrefixes(item.toLowerCase()));
    }
    if (Array.isArray(item))
      item.map(
        (item2) => acceptedArrayItems.push(removeBrandPrefixes(item2?.toLowerCase()))
      );
    return acceptedArrayItems;
  });
  const shouldComponentRender = (Comp2) => {
    const CompName = getComponentName(Comp2);
    const should = acceptedArrayItems.includes(CompName?.toLowerCase()) || _accepts.includes(CompName?.toLowerCase()) || ["any", "template", "Any"].includes(_accepts[0]);
    if (!should) {
      console.warn("Did not render", {
        CompName,
        acceptedArrayItems,
        _accepts
      });
    }
    return should;
  };
  if (Comp?.$$typeof === Symbol.for("react.element") && Comp.type !== Symbol.for("react.fragment")) {
    if (shouldComponentRender(Comp)) {
      if (!hasStyle)
        return RenderComponent(Comp, {
          ...events,
          ...Comp.props,
          style: { ...rest["style"], ...Comp?.props?.style },
          slot_layers
        });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className,
          style: {
            ...style,
            pointerEvents: disabled ? "none" : void 0
          },
          children: RenderComponent(Comp, {
            ...events,
            ...Comp.props,
            style: { ...rest["style"], ...Comp?.props?.style },
            slot_layers
          })
        }
      );
    }
  }
  if (Array.isArray(Comp)) {
    if (children?.[layer]?.max) {
      if (!hasStyle)
        return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map(
          (Item, i) => RenderComponent(Item, {
            key: getComponentName(Item) + i,
            ...events,
            slot_layers
          })
        ) });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className,
          style: {
            ...style,
            pointerEvents: disabled ? "none" : void 0
          },
          children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map(
            (Item, i) => RenderComponent(Item, {
              key: getComponentName(Item) + i,
              ...events,
              slot_layers
            })
          )
        }
      );
    }
    if (!hasStyle)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Comp.filter(shouldComponentRender).map(
        (Item, i) => RenderComponent(Item, {
          key: getComponentName(Item) + i,
          ...events,
          slot_layers
        })
      ) });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className,
        style: {
          ...style,
          pointerEvents: disabled ? "none" : void 0
        },
        children: Comp.filter(shouldComponentRender).map(
          (Item, i) => RenderComponent(Item, {
            key: getComponentName(Item) + i,
            ...events,
            slot_layers
          })
        )
      }
    );
  }
  const renderFragment = (Comp2) => {
    let ComponentChildren;
    if (children?.[layer]?.max || Array.isArray(Comp2.props.children)) {
      ComponentChildren = Comp2.props.children.slice?.(0, children?.[layer]?.max).map((item) => {
        if (item?.type === Symbol.for("react.fragment")) {
          return renderFragment(item);
        } else if (item) {
          return shouldComponentRender(item) && RenderComponent(item, { ...item.props, slot_layers });
        }
        return null;
      });
      if (!hasStyle)
        return ComponentChildren;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className,
          style: {
            ...style,
            pointerEvents: disabled ? "none" : void 0
          },
          children: ComponentChildren.map(
            (child) => shouldComponentRender(child) && RenderComponent(child, { ...child.props, slot_layers })
          )
        }
      );
    }
    ComponentChildren = Comp2.props.children;
    return ComponentChildren.map(
      (child) => shouldComponentRender(child) && RenderComponent(child, { ...child.props, slot_layers })
    );
  };
  if (typeof Comp === "object" && Comp.$$typeof === Symbol.for("react.element") && Comp.type === Symbol.for("react.fragment")) {
    return renderFragment(Comp);
  }
  return null;
};

const Text = ({
  value,
  events: { ...restEvents } = {},
  className,
  style,
  layer,
  textType = "div",
  role,
  "aria-describedby": ariaDescribedby,
  ...rest
}) => {
  if (typeof value === "undefined" || value === "")
    return null;
  const currentStyle = typeof style === "object" ? style : {};
  const Type = textType?.trim() === "" ? "div" : textType;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Animated,
    {
      hidden: ["true", true].includes(rest.hidden),
      animatedProperties: rest.transition?.property,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Type,
        {
          className,
          style: {
            display: rest["max-lines"] ? "-webkit-box" : "table",
            "--max-lines": rest["max-lines"],
            overflow: rest["max-lines"] ? "hidden" : void 0,
            ...currentStyle
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              id: layer,
              className: ["text-atom"].join(" "),
              style: {
                display: rest["max-lines"] ? "-webkit-box" : "block",
                "--max-lines": rest["max-lines"]
              },
              ...restEvents,
              "data-testid": rest["data-testid"],
              role,
              "aria-describedby": ariaDescribedby,
              children: value
            }
          )
        }
      )
    }
  );
};

const Textarea = (props) => {
  const classNames = ["jds-input-textarea-atom"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", { ...props, className: classNames.join(" ") });
};

const VerticalTip = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: props.className,
    style: {
      boxSizing: "content-box",
      background: "transparent"
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "svg",
      {
        ...props,
        className: props.svgClassName,
        width: "8",
        height: "24",
        viewBox: "0 0 8 24",
        fill: props["background-color"],
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector 5",
            d: "M6.87661 14.4244L2.7121 18.1471C0.97557 19.6994 -9.59586e-08 21.8047 0 24L-1.04907e-06 -2.38419e-07C-9.53115e-07 2.19528 0.975566 4.30064 2.71209 5.85293L6.87661 9.57563C8.37446 10.9146 8.37446 13.0854 6.87661 14.4244Z"
          }
        )
      }
    )
  }
);
const HorizontalTip = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: props.className,
    style: {
      display: "flex",
      flexDirection: "column",
      background: "transparent"
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "svg",
      {
        ...props,
        className: props.svgClassName,
        width: "24",
        height: "8",
        viewBox: "0 0 24 8",
        fill: props["background-color"],
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector 5",
            d: "M14.4244 1.12338L18.1471 5.2879C19.6994 7.02443 21.8047 8 24 8L-2.38419e-07 8C2.19528 8 4.30064 7.02443 5.85294 5.28791L9.57564 1.12339C10.9146 -0.374462 13.0854 -0.374465 14.4244 1.12338Z"
          }
        )
      }
    )
  }
);
const svgDirectionConfig = {
  vertical: VerticalTip,
  horizontal: HorizontalTip
};
const Tip = (props) => {
  const { position = "right", className } = props;
  const positionPrefix = position.split("_")?.[0].toLowerCase();
  const tipClass = `j_tooltip-tip-${positionPrefix}`;
  const direction = ["top", "bottom"].includes(positionPrefix) ? "horizontal" : "vertical";
  const Component = svgDirectionConfig[direction];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props, className, svgClassName: tipClass });
};

const atomsMap = {
  container: Container,
  text: Text,
  icon: Icon,
  image: Image,
  slider: Slider,
  animatedContainer: AnimatedContainer,
  loader: Loader,
  link: Link,
  popup: Popup,
  textarea: Textarea,
  tooltip: Tip,
  input: Input,
  promoCardArc: PromoCardArc,
  arc: Arc,
  slot: Slot,
  skeletonLoader: SkeletonAnimatedLayer,
  button_vector: ButtonVector
};
const isAtomic = (layer) => {
  const baseLayerName = getBaseLayerName(layer);
  return Object.keys(atomsMap).includes(baseLayerName);
};

const createComponent = (componentProperties, props, componentName = "component", componentsMap, _custom = {}) => {
  const { hierarchy, api, ...rest } = componentProperties;
  const customMergedJSON = merge({ api, ...rest }, _custom);
  const normalisedProperties = processConfigAPI(api.config, props);
  const uiTokens = getLayersProps(
    { ...props, ...normalisedProperties },
    cloneDeep(customMergedJSON)
  );
  const { layerProps, styles } = seperateComponentLayerProps(uiTokens);
  const propMergedStyles = mergeStyleProperties(
    props,
    styles,
    api.data,
    layerProps
  );
  return renderComponentTopHierarchy(
    hierarchy,
    api,
    propMergedStyles,
    props,
    customMergedJSON?.metadata?.name || componentName,
    layerProps,
    componentsMap
  );
};
const renderComponentTopHierarchy = (hierarchy_, api, styles_, props, componentName, layerProps, componentsMap) => {
  const { events } = api;
  const { hierarchy, styles } = hiddenFilter({
    hierarchy_,
    styles_,
    api,
    props
  });
  const rootLayer = Object.keys(hierarchy)[0];
  const tokens = {
    ...useTokenValues()
  };
  const { processData, processedEvents, processedChildren, processedA11y } = processDataAPI(api, rootLayer, props);
  const processedConfigAPI = processConfigAPI(api.config, props, layerProps);
  const newProps = {
    ...processedConfigAPI,
    ...layerProps[rootLayer],
    ...processData,
    ...processedA11y
  };
  const RootComponent = rootLayer && getCompFromKey(rootLayer, componentsMap);
  const { modifiedBase } = updateLayersWithParentTokens(
    tokens,
    styles,
    hierarchy
  );
  if (RootComponent) {
    const style = drawComponent(componentName, modifiedBase, hierarchy_);
    const className = getLayerClass(componentName, rootLayer);
    const listName = api.data[rootLayer]?.["value"]?.name;
    const arrayData = api.data[rootLayer]?.["value"]?.type === "list" ? props[listName] : void 0;
    const currentEvents = isAtomic(rootLayer) ? { events: processedEvents } : { ...processedEvents };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      RootComponent,
      {
        ...newProps,
        ...currentEvents,
        rootRef: props.rootRef,
        layer: rootLayer,
        root: true,
        disabled: layerProps[rootLayer]?.["disabled"] || props.disabled,
        style: {
          ...STYLE_ALLOWED_COMPONENTS.includes(componentName) ? props.style : {},
          ...style
        },
        "data-testid": getLayerTestId(componentName, rootLayer),
        internalIndex: props.internalIndex,
        className: [className, props.className].join(" "),
        children: arrayData ? arrayData?.map((arrayItem, i) => {
          return renderComponent(
            Object.values(hierarchy)[0],
            events,
            api,
            { ...props, ...arrayItem },
            componentName,
            processedChildren,
            componentsMap,
            layerProps,
            arrayItem.internalIndex || i
          );
        }) : renderComponent(
          Object.values(hierarchy)[0],
          events,
          api,
          { ...props },
          componentName,
          processedChildren,
          componentsMap,
          layerProps
        )
      },
      Object.keys(hierarchy)[0]
    );
  }
  return null;
};
const renderComponent = (currentLayer, eventsAPI, dataAPI, props, componentName, children, componentsMap, layerProps, internalIndex, a11y) => {
  if (typeof currentLayer === "string") {
    const CurrentComp = getCompFromKey(currentLayer, componentsMap);
    const { processData, processedEvents, processedA11y } = processDataAPI(
      dataAPI,
      currentLayer,
      props
    );
    if (CurrentComp) {
      const processedConfigAPI = processConfigAPI(dataAPI.config, props);
      const newProps = merge(
        processedConfigAPI,
        layerProps?.[currentLayer],
        processData,
        { events: processedEvents },
        processedA11y
      );
      const className = getLayerClass(componentName, currentLayer);
      const isAtomicLayer = isAtomic(currentLayer);
      const Component = /* @__PURE__ */ jsxRuntimeExports.jsx(
        CurrentComp,
        {
          layer: currentLayer,
          "data-testid": getLayerTestId(componentName, currentLayer),
          _childrenProps: { api: children, props },
          disabled: props.disabled || layerProps?.[currentLayer]?.["disabled"],
          ...newProps,
          ...newProps.events,
          className,
          internalIndex: internalIndex || 0,
          processedA11y
        },
        currentLayer
      );
      if (!isValidElement(Component))
        return null;
      if (!isAtomicLayer) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { display: "contents" }, className, children: Component });
      }
      return Component;
    }
  } else if (typeof currentLayer === "object" && !Array.isArray(currentLayer)) {
    return Object.keys(currentLayer).map((layer) => {
      const CurrentComp = getCompFromKey(layer, componentsMap);
      const { processData, processedEvents, processedA11y } = processDataAPI(dataAPI, layer, props) || {};
      if (CurrentComp) {
        const processedConfigAPI = processConfigAPI(dataAPI.config, props);
        const newProps = {
          ...processedConfigAPI,
          ...layerProps?.[layer],
          ...processData,
          ...processedEvents,
          ...processedA11y
        };
        const listName = dataAPI.data[layer]?.["value"]?.name;
        const arrayData = dataAPI.data[layer]?.["value"]?.type === "list" ? props[listName] : void 0;
        const className = getLayerClass(componentName, layer);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          CurrentComp,
          {
            "data-testid": getLayerTestId(componentName, layer),
            ...newProps,
            layer,
            className,
            events: processedEvents,
            disabled: props.disabled || layerProps?.[layer]?.["disabled"],
            internalIndex,
            processedA11y,
            children: arrayData ? arrayData?.map((valueItem, i) => {
              return renderComponent(
                currentLayer[layer],
                eventsAPI,
                dataAPI,
                { ...props, ...valueItem, internalIndex: i },
                componentName,
                children,
                componentsMap,
                layerProps,
                valueItem.internalIndex || i);
            }) : renderComponent(
              currentLayer[layer],
              eventsAPI,
              dataAPI,
              { ...props },
              componentName,
              children,
              componentsMap,
              layerProps,
              internalIndex)
          },
          layer
        );
      }
      return null;
    });
  } else if (typeof currentLayer === "object" && Array.isArray(currentLayer)) {
    return currentLayer.map((child) => {
      return renderComponent(
        child,
        eventsAPI,
        dataAPI,
        props,
        componentName,
        children,
        componentsMap,
        layerProps,
        internalIndex);
    });
  }
  return null;
};
const getCompFromKey = (obj, componentsMap) => {
  const layerName = getBaseLayerName(obj);
  if (isAtomic(layerName))
    return atomsMap[layerName] || null;
  if (!componentsMap)
    return null;
  try {
    return componentsMap[layerName]?.() || null;
  } catch (error) {
    return null;
  }
};
const excludedLayers = [
  "input",
  "container",
  "arc",
  "slider",
  "loader",
  "button_vector",
  "skeletonLoader"
];
const hasProps = (layerName = "", api, props, styles) => {
  if (excludedLayers.some((layer) => layerName.endsWith(layer)))
    return true;
  if (styles?.[layerName]?.transition)
    return true;
  const apiLayers = api.data?.[layerName];
  const childlayers = api.children?.[layerName];
  if (!apiLayers && !childlayers && Object.values(apiLayers || {}).every(({ type }) => type === "boolean"))
    return true;
  const hasChildren = Boolean(props?.[childlayers?.name]);
  const hasData = Object.values(apiLayers || {}).some(
    ({ name }) => typeof props[name] !== "undefined" || typeof styles?.[layerName]?.[name] !== "undefined" || name.includes(".")
  );
  const hasBaseProps = Object.keys((styles || {})[layerName] || {}).length;
  if (!hasData && hasBaseProps)
    return true;
  if (!hasData && !(hasChildren && childlayers))
    return false;
  return true;
};
const hiddenFilter = ({
  hierarchy_,
  styles_,
  api,
  props
}) => {
  const hiddenLayers = [];
  const styles = Object.entries(styles_).reduce(
    (acc, [layerName, styleProps]) => {
      if (isHidden(styleProps.hidden) && !styleProps?.["transition"]) {
        hiddenLayers.push(layerName);
      } else {
        acc[layerName] = styleProps;
      }
      return acc;
    },
    {}
  );
  const hierarchy = filterHierarchy(
    hierarchy_,
    hiddenLayers,
    api,
    props,
    styles
  );
  return { hierarchy, styles };
};
const isHidden = (hidden) => {
  if (typeof hidden === "string") {
    return hidden.includes("true");
  }
  return Boolean(hidden);
};
const isLayerHidden = (layer, hiddenLayers) => {
  return hiddenLayers.includes(layer);
};
const filterHierarchy = (hierarchy, hiddenLayers, api, props, styles) => {
  if (typeof hierarchy === "string" && !isLayerHidden(hierarchy, hiddenLayers) && hasProps(hierarchy, api, props, styles)) {
    return hierarchy;
  } else if (typeof hierarchy === "object" && !Array.isArray(hierarchy)) {
    const end = Object.keys(hierarchy).filter((key) => {
      return !isLayerHidden(key, hiddenLayers) && hasProps(key, api, props);
    }).reduce((res, key) => {
      res[key] = filterHierarchy(
        hierarchy[key],
        hiddenLayers,
        api,
        props,
        styles
      );
      return res;
    }, {});
    return end;
  } else if (typeof hierarchy === "object" && Array.isArray(hierarchy)) {
    const res = [];
    hierarchy.forEach((key) => {
      res.push(filterHierarchy(key, hiddenLayers, api, props, styles));
    });
    return res.filter((r) => Object.keys(r).length).flat();
  }
  return {};
};

const English$6 = {
	of: "of"
};
const Hindi$6 = {
	of: "का"
};
const Marathi$6 = {
	of: "च्या"
};
const Gujarati$6 = {
	of: "ના"
};
const Punjabi$6 = {
	of: "ਦੇ"
};
const Bengali$6 = {
	of: "এর"
};
const Tamil$6 = {
	of: "இன்"
};
const Telugu$6 = {
	of: "యొక్క"
};
const Kannada$6 = {
	of: "ನ"
};
const Assamese$6 = {
	of: "ৰ"
};
const Malayalam$6 = {
	of: "യുടെ"
};
const Oriya$6 = {
	of: "ର"
};
const of = {
	English: English$6,
	Hindi: Hindi$6,
	Marathi: Marathi$6,
	Gujarati: Gujarati$6,
	Punjabi: Punjabi$6,
	Bengali: Bengali$6,
	Tamil: Tamil$6,
	Telugu: Telugu$6,
	Kannada: Kannada$6,
	Assamese: Assamese$6,
	Malayalam: Malayalam$6,
	Oriya: Oriya$6
};

const ofData = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  Assamese: Assamese$6,
  Bengali: Bengali$6,
  English: English$6,
  Gujarati: Gujarati$6,
  Hindi: Hindi$6,
  Kannada: Kannada$6,
  Malayalam: Malayalam$6,
  Marathi: Marathi$6,
  Oriya: Oriya$6,
  Punjabi: Punjabi$6,
  Tamil: Tamil$6,
  Telugu: Telugu$6,
  default: of
}, Symbol.toStringTag, { value: 'Module' }));

const English$5 = {
	ConfirmButton: "Confirm"
};
const Hindi$5 = {
	ConfirmButton: "पुष्टि करें"
};
const Marathi$5 = {
	ConfirmButton: "पुष्टी"
};
const Gujarati$5 = {
	ConfirmButton: "પુષ્ટિ કરો"
};
const Punjabi$5 = {
	ConfirmButton: "ਪੁਸ਼ਟੀ ਕਰੋ"
};
const Bengali$5 = {
	ConfirmButton: "নিশ্চিত করুন"
};
const Tamil$5 = {
	ConfirmButton: "உறுதிப்படுத்தவும்"
};
const Telugu$5 = {
	ConfirmButton: "నిర్ధారించండి"
};
const Kannada$5 = {
	ConfirmButton: "ದೃಢೀಕರಿಸಿ"
};
const Assamese$5 = {
	ConfirmButton: "নিশ্চিত"
};
const Malayalam$5 = {
	ConfirmButton: "സ്ഥിരീകരിക്കുക"
};
const Oriya$5 = {
	ConfirmButton: "ନିଶ୍ଚିତ କରନ୍ତୁ |"
};
const confirmButtonData = {
	English: English$5,
	Hindi: Hindi$5,
	Marathi: Marathi$5,
	Gujarati: Gujarati$5,
	Punjabi: Punjabi$5,
	Bengali: Bengali$5,
	Tamil: Tamil$5,
	Telugu: Telugu$5,
	Kannada: Kannada$5,
	Assamese: Assamese$5,
	Malayalam: Malayalam$5,
	Oriya: Oriya$5
};

const as = "Assamese";
const bn = "Bengali";
const en = "English";
const gu = "Gujarati";
const hi = "Hindi";
const kn = "Kannada";
const ml = "Malayalam";
const mr = "Marathi";
const or = "Oriya";
const pa = "Punjabi";
const ta = "Tamil";
const te = "Telugu";
const localeLanguageData = {
	as: as,
	bn: bn,
	en: en,
	gu: gu,
	hi: hi,
	kn: kn,
	ml: ml,
	mr: mr,
	or: or,
	pa: pa,
	ta: ta,
	te: te
};

const English$4 = {
	zero: "0",
	one: "1",
	two: "2",
	three: "3",
	four: "4",
	five: "5",
	six: "6",
	seven: "7",
	eight: "8",
	nine: "9",
	ten: "10",
	eleven: "11",
	twelve: "12",
	thirteen: "13",
	fourteen: "14",
	fifteen: "15",
	sixteen: "16",
	seventeen: "17",
	eighteen: "18",
	nineteen: "19",
	twenty: "20",
	twenty_one: "21",
	twenty_two: "22",
	twenty_three: "23",
	twenty_four: "24",
	twenty_five: "25",
	twenty_six: "26",
	twenty_seven: "27",
	twenty_eight: "28",
	twenty_nine: "29",
	thirty: "30",
	thirty_one: "31"
};
const Hindi$4 = {
	zero: "०",
	one: "१",
	two: "२",
	three: "३",
	four: "४",
	five: "५",
	six: "६",
	seven: "७",
	eight: "८",
	nine: "९",
	ten: "१०",
	eleven: "११",
	twelve: "१२",
	thirteen: "१३",
	fourteen: "१४",
	fifteen: "१५",
	sixteen: "१६",
	seventeen: "१७",
	eighteen: "१८",
	nineteen: "१९",
	twenty: "२०",
	twenty_one: "२१",
	twenty_two: "२२",
	twenty_three: "२३",
	twenty_four: "२४",
	twenty_five: "२५",
	twenty_six: "२६",
	twenty_seven: "२७",
	twenty_eight: "२८",
	twenty_nine: "२९",
	thirty: "३०",
	thirty_one: "३१"
};
const Marathi$4 = {
	zero: "०",
	one: "१",
	two: "२",
	three: "३",
	four: "४",
	five: "५",
	six: "६",
	seven: "७",
	eight: "८",
	nine: "९",
	ten: "१०",
	eleven: "११",
	twelve: "१२",
	thirteen: "१३",
	fourteen: "१४",
	fifteen: "१५",
	sixteen: "१६",
	seventeen: "१७",
	eighteen: "१८",
	nineteen: "१९",
	twenty: "२०",
	twenty_one: "२१",
	twenty_two: "२२",
	twenty_three: "२३",
	twenty_four: "२४",
	twenty_five: "२५",
	twenty_six: "२६",
	twenty_seven: "२७",
	twenty_eight: "२८",
	twenty_nine: "२९",
	thirty: "३०",
	thirty_one: "३१"
};
const Gujarati$4 = {
	zero: "૦",
	one: "૧",
	two: "૨",
	three: "૩",
	four: "૪",
	five: "૫",
	six: "૬",
	seven: "૭",
	eight: "૮",
	nine: "૯",
	ten: "૧૦",
	eleven: "૧૧",
	twelve: "૧૨",
	thirteen: "૧૩",
	fourteen: "૧૪",
	fifteen: "૧૫",
	sixteen: "૧૬",
	seventeen: "૧૭",
	eighteen: "૧૮",
	nineteen: "૧૯",
	twenty: "૨૦",
	twenty_one: "૨૧",
	twenty_two: "૨૨",
	twenty_three: "૨૩",
	twenty_four: "૨૪",
	twenty_five: "૨૫",
	twenty_six: "૨૬",
	twenty_seven: "૨૭",
	twenty_eight: "૨૮",
	twenty_nine: "૨૯",
	thirty: "૩૦",
	thirty_one: "૩૧"
};
const Punjabi$4 = {
	zero: "੦",
	one: "੧",
	two: "੨",
	three: "੩",
	four: "੪",
	five: "੫",
	six: "੬",
	seven: "੭",
	eight: "੮",
	nine: "੯",
	ten: "੧੦",
	eleven: "੧੧",
	twelve: "੧੨",
	thirteen: "੧੩",
	fourteen: "੧੪",
	fifteen: "੧੫",
	sixteen: "੧੬",
	seventeen: "੧੭",
	eighteen: "੧੮",
	nineteen: "੧੯",
	twenty: "੨੦",
	twenty_one: "੨੧",
	twenty_two: "੨੨",
	twenty_three: "੨੩",
	twenty_four: "੨੪",
	twenty_five: "੨੫",
	twenty_six: "੨੬",
	twenty_seven: "੨੭",
	twenty_eight: "੨੮",
	twenty_nine: "੨੯",
	thirty: "੩੦",
	thirty_one: "੩੧"
};
const Bengali$4 = {
	zero: "০",
	one: "১",
	two: "২",
	three: "৩",
	four: "৪",
	five: "৫",
	six: "৬",
	seven: "৭",
	eight: "৮",
	nine: "৯",
	ten: "১০",
	eleven: "১১",
	twelve: "১২",
	thirteen: "১৩",
	fourteen: "১৪",
	fifteen: "১৫",
	sixteen: "১৬",
	seventeen: "১৭",
	eighteen: "১৮",
	nineteen: "১৯",
	twenty: "২০",
	twenty_one: "২১",
	twenty_two: "২২",
	twenty_three: "২৩",
	twenty_four: "২৪",
	twenty_five: "২৫",
	twenty_six: "২৬",
	twenty_seven: "২৭",
	twenty_eight: "২৮",
	twenty_nine: "২৯",
	thirty: "৩০",
	thirty_one: "৩১"
};
const Tamil$4 = {
	zero: "௦",
	one: "௧",
	two: "௨",
	three: "௩",
	four: "௪",
	five: "௫",
	six: "௬",
	seven: "௭",
	eight: "௮",
	nine: "௯",
	ten: "௧௦",
	eleven: "௧௧",
	twelve: "௧௨",
	thirteen: "௧௩",
	fourteen: "௧௪",
	fifteen: "௧௫",
	sixteen: "௧௬",
	seventeen: "௧௭",
	eighteen: "௧௮",
	nineteen: "௧௯",
	twenty: "௨௦",
	twenty_one: "௨௧",
	twenty_two: "௨௨",
	twenty_three: "௨௩",
	twenty_four: "௨௪",
	twenty_five: "௨௫",
	twenty_six: "௨௬",
	twenty_seven: "௨௭",
	twenty_eight: "௨௮",
	twenty_nine: "௨௯",
	thirty: "௩௦",
	thirty_one: "௩௧"
};
const Telugu$4 = {
	zero: "౦",
	one: "౧",
	two: "౨",
	three: "౩",
	four: "౪",
	five: "౫",
	six: "౬",
	seven: "౭",
	eight: "౮",
	nine: "౯",
	ten: "౧౦",
	eleven: "౧౧",
	twelve: "౧౨",
	thirteen: "౧౩",
	fourteen: "౧౪",
	fifteen: "౧౫",
	sixteen: "౧౬",
	seventeen: "౧౭",
	eighteen: "౧౮",
	nineteen: "౧౯",
	twenty: "౨౦",
	twenty_one: "౨౧",
	twenty_two: "౨౨",
	twenty_three: "౨౩",
	twenty_four: "౨౪",
	twenty_five: "౨౫",
	twenty_six: "౨౬",
	twenty_seven: "౨౭",
	twenty_eight: "౨౮",
	twenty_nine: "౨౯",
	thirty: "౩౦",
	thirty_one: "౩౧"
};
const Kannada$4 = {
	zero: "೦",
	one: "೧",
	two: "೨",
	three: "೩",
	four: "೪",
	five: "೫",
	six: "೬",
	seven: "೭",
	eight: "೮",
	nine: "೯",
	ten: "೧೦",
	eleven: "೧೧",
	twelve: "೧೨",
	thirteen: "೧೩",
	fourteen: "೧೪",
	fifteen: "೧೫",
	sixteen: "೧೬",
	seventeen: "೧೭",
	eighteen: "೧೮",
	nineteen: "೧೯",
	twenty: "೨೦",
	twenty_one: "೨೧",
	twenty_two: "೨೨",
	twenty_three: "೨೩",
	twenty_four: "೨೪",
	twenty_five: "೨೫",
	twenty_six: "೨೬",
	twenty_seven: "೨೭",
	twenty_eight: "೨೮",
	twenty_nine: "೨೯",
	thirty: "೩೦",
	thirty_one: "೩೧"
};
const Assamese$4 = {
	zero: "০",
	one: "১",
	two: "২",
	three: "৩",
	four: "৪",
	five: "৫",
	six: "৬",
	seven: "৭",
	eight: "৮",
	nine: "৯",
	ten: "১০",
	eleven: "১১",
	twelve: "১২",
	thirteen: "১৩",
	fourteen: "১৪",
	fifteen: "১৫",
	sixteen: "১৬",
	seventeen: "১৭",
	eighteen: "১৮",
	nineteen: "১৯",
	twenty: "২০",
	twenty_one: "২১",
	twenty_two: "২২",
	twenty_three: "২৩",
	twenty_four: "২৪",
	twenty_five: "২৫",
	twenty_six: "২৬",
	twenty_seven: "২৭",
	twenty_eight: "২৮",
	twenty_nine: "২৯",
	thirty: "৩০",
	thirty_one: "৩১"
};
const Malayalam$4 = {
	zero: "൦",
	one: "൧",
	two: "൨",
	three: "൩",
	four: "൪",
	five: "൫",
	six: "൬",
	seven: "൭",
	eight: "൮",
	nine: "൯",
	ten: "൧൦",
	eleven: "൧൧",
	twelve: "൧൨",
	thirteen: "൧൩",
	fourteen: "൧൪",
	fifteen: "൧൫",
	sixteen: "൧൬",
	seventeen: "൧൭",
	eighteen: "൧൮",
	nineteen: "൧൯",
	twenty: "൨൦",
	twenty_one: "൨൧",
	twenty_two: "൨൨",
	twenty_three: "൨൩",
	twenty_four: "൨൪",
	twenty_five: "൨൫",
	twenty_six: "൨൬",
	twenty_seven: "൨൭",
	twenty_eight: "൨൮",
	twenty_nine: "൨൯",
	thirty: "൩൦",
	thirty_one: "൩൧"
};
const Oriya$4 = {
	zero: "୦",
	one: "୧",
	two: "୨",
	three: "୩",
	four: "୪",
	five: "୫",
	six: "୬",
	seven: "୭",
	eight: "୮",
	nine: "୯",
	ten: "୧୦",
	eleven: "୧୧",
	twelve: "୧୨",
	thirteen: "୧୩",
	fourteen: "୧୪",
	fifteen: "୧୫",
	sixteen: "୧୬",
	seventeen: "୧୭",
	eighteen: "୧୮",
	nineteen: "୧୯",
	twenty: "୨୦",
	twenty_one: "୨୧",
	twenty_two: "୨୨",
	twenty_three: "୨୩",
	twenty_four: "୨୪",
	twenty_five: "୨୫",
	twenty_six: "୨୬",
	twenty_seven: "୨୭",
	twenty_eight: "୨୮",
	twenty_nine: "୨୯",
	thirty: "୩୦",
	thirty_one: "୩୧"
};
const monthDatesData = {
	English: English$4,
	Hindi: Hindi$4,
	Marathi: Marathi$4,
	Gujarati: Gujarati$4,
	Punjabi: Punjabi$4,
	Bengali: Bengali$4,
	Tamil: Tamil$4,
	Telugu: Telugu$4,
	Kannada: Kannada$4,
	Assamese: Assamese$4,
	Malayalam: Malayalam$4,
	Oriya: Oriya$4
};

const English$3 = {
	January: "January",
	February: "February",
	March: "March",
	April: "April",
	May: "May",
	June: "June",
	July: "July",
	August: "August",
	September: "September",
	October: "October",
	November: "November",
	December: "December"
};
const Hindi$3 = {
	January: "जनवरी",
	February: "फरवरी",
	March: "मार्च",
	April: "अप्रैल",
	May: "मई",
	June: "जून",
	July: "जुलाई",
	August: "अगस्त",
	September: "सितंबर",
	October: "अक्टूबर",
	November: "नवंबर",
	December: "दिसंबर"
};
const Marathi$3 = {
	January: "जानेवारी",
	February: "फेब्रुवारी",
	March: "मार्च",
	April: "एप्रिल",
	May: "मे",
	June: "जून",
	July: "जुलै",
	August: "ऑगस्ट",
	September: "सप्टेंबर",
	October: "ऑक्टोबर",
	November: "नोव्हेंबर",
	December: "डिसेंबर"
};
const Gujarati$3 = {
	January: "જાન્યુઆરી",
	February: "ફેબ્રુઆરી",
	March: "માર્ચ",
	April: "એપ્રિલ",
	May: "મે",
	June: "જૂન",
	July: "જુલાઈ",
	August: "ઑગસ્ટ",
	September: "સપ્ટેમ્બર",
	October: "ઓક્ટોબર",
	November: "નવેમ્બર",
	December: "ડિસેમ્બર"
};
const Punjabi$3 = {
	January: "ਜਨਵਰੀ",
	February: "ਫਰਵਰੀ",
	March: "ਮਾਰਚ",
	April: "ਅਪ੍ਰੈਲ",
	May: "ਮਈ",
	June: "ਜੂਨ",
	July: "ਜੁਲਾਈ",
	August: "ਅਗਸਤ",
	September: "ਸਤੰਬਰ",
	October: "ਅਕਤੂਬਰ",
	November: "ਨਵੰਬਰ",
	December: "ਦਸੰਬਰ"
};
const Bengali$3 = {
	January: "জানুয়ারি",
	February: "ফেব্রুয়ারি",
	March: "মার্চ",
	April: "এপ্রিল",
	May: "মে",
	June: "জুন",
	July: "জুলাই",
	August: "অগাস্ট",
	September: "সেপ্টেম্বর",
	October: "অক্টোবর",
	November: "নভেম্বর",
	December: "ডিসেম্বর"
};
const Tamil$3 = {
	January: "ஜனவரி",
	February: "பிப்ரவரி",
	March: "மார்ச்",
	April: "ஏப்ரல்",
	May: "மே",
	June: "ஜூன்",
	July: "ஜூலை",
	August: "ஆகஸ்டு",
	September: "செப்டம்பர்",
	October: "அக்டோபர்",
	November: "நவம்பர்",
	December: "டிசம்பர்"
};
const Telugu$3 = {
	January: "జనవరి",
	February: "ఫిబ్రవరి",
	March: "మార్చి",
	April: "ఏప్రిల్",
	May: "మే",
	June: "జూన్",
	July: "జులై",
	August: "ఆగష్టు",
	September: "సెప్టెంబర్",
	October: "అక్టోబర్",
	November: "నవంబర్",
	December: "డిసెంబర్"
};
const Kannada$3 = {
	January: "ಜನವರಿ",
	February: "ಫೆಬ್ರವರಿ",
	March: "ಮಾರ್ಚ್",
	April: "ಏಪ್ರಿಲ್",
	May: "ಮೇ",
	June: "ಜೂನ್",
	July: "ಜುಲೈ",
	August: "ಆಗಸ್ಟ್",
	September: "ಸೆಪ್ಟೆಂಬರ್",
	October: "ಅಕ್ಟೋಬರ್",
	November: "ನವೆಂಬರ್",
	December: "ಡಿಸೆಂಬರ್"
};
const Assamese$3 = {
	January: "জানুৱাৰী",
	February: "ফেব্ৰুৱাৰী",
	March: "মাৰ্চ",
	April: "এপ্ৰিল",
	May: "মে",
	June: "জুন",
	July: "জুলাই",
	August: "আগষ্ট",
	September: "ছেপ্টেম্বৰ",
	October: "অক্টোবৰ",
	November: "নৱেম্বৰ",
	December: "ডিচেম্বৰ"
};
const Malayalam$3 = {
	January: "ജനുവരി",
	February: "ഫെബ്രുവരി",
	March: "മാർച്ച്",
	April: "ഏപ്രിൽ",
	May: "മേയ്",
	June: "ജൂൺ",
	July: "ജൂലൈ",
	August: "ഓഗസ്റ്റ്",
	September: "സെപ്റ്റംബർ",
	October: "ഒക്ടോബർ",
	November: "നവംബർ",
	December: "ഡിസംബർ"
};
const Oriya$3 = {
	January: "ଜାନୁଆରୀ",
	February: "ଫେବୃୟାରୀ",
	March: "ମାର୍ଚ୍",
	April: "ଏପ୍ରିଲ",
	May: "ମେ",
	June: "ଜୁନ",
	July: "ଜୁଲାଇ",
	August: "ଅଗଷ୍ଟ",
	September: "ସେପ୍ଟେମ୍ବର",
	October: "ଅକ୍ଟୋବର",
	November: "ନଭେମ୍ବର",
	December: "ଡିସେମ୍ବର"
};
const monthNamesData = {
	English: English$3,
	Hindi: Hindi$3,
	Marathi: Marathi$3,
	Gujarati: Gujarati$3,
	Punjabi: Punjabi$3,
	Bengali: Bengali$3,
	Tamil: Tamil$3,
	Telugu: Telugu$3,
	Kannada: Kannada$3,
	Assamese: Assamese$3,
	Malayalam: Malayalam$3,
	Oriya: Oriya$3
};

const English$2 = {
	zero: "0",
	one: "1",
	two: "2",
	three: "3",
	four: "4",
	five: "5",
	six: "6",
	seven: "7",
	eight: "8",
	nine: "9"
};
const Hindi$2 = {
	zero: "०",
	one: "१",
	two: "२",
	three: "३",
	four: "४",
	five: "५",
	six: "६",
	seven: "७",
	eight: "८",
	nine: "९"
};
const Marathi$2 = {
	zero: "०",
	one: "१",
	two: "२",
	three: "३",
	four: "४",
	five: "५",
	six: "६",
	seven: "७",
	eight: "८",
	nine: "९"
};
const Gujarati$2 = {
	zero: "૦",
	one: "૧",
	two: "૨",
	three: "૩",
	four: "૪",
	five: "૫",
	six: "૬",
	seven: "૭",
	eight: "૮",
	nine: "૯"
};
const Punjabi$2 = {
	zero: "੦",
	one: "੧",
	two: "੨",
	three: "੩",
	four: "੪",
	five: "੫",
	six: "੬",
	seven: "੭",
	eight: "੮",
	nine: "੯"
};
const Bengali$2 = {
	zero: "০",
	one: "১",
	two: "২",
	three: "৩",
	four: "৪",
	five: "৫",
	six: "৬",
	seven: "৭",
	eight: "৮",
	nine: "৯"
};
const Tamil$2 = {
	zero: "௦",
	one: "௧",
	two: "௨",
	three: "௩",
	four: "௪",
	five: "௫",
	six: "௬",
	seven: "௭",
	eight: "௮",
	nine: "௯"
};
const Telugu$2 = {
	zero: "౦",
	one: "౧",
	two: "౨",
	three: "౩",
	four: "౪",
	five: "౫",
	six: "౬",
	seven: "౭",
	eight: "౮",
	nine: "౯"
};
const Kannada$2 = {
	zero: "೦",
	one: "೧",
	two: "೨",
	three: "೩",
	four: "೪",
	five: "೫",
	six: "೬",
	seven: "೭",
	eight: "೮",
	nine: "೯"
};
const Assamese$2 = {
	zero: "০",
	one: "১",
	two: "২",
	three: "৩",
	four: "৪",
	five: "৫",
	six: "৬",
	seven: "৭",
	eight: "৮",
	nine: "৯"
};
const Malayalam$2 = {
	zero: "൦",
	one: "൧",
	two: "൨",
	three: "൩",
	four: "൪",
	five: "൫",
	six: "൬",
	seven: "൭",
	eight: "൮",
	nine: "൯"
};
const Oriya$2 = {
	zero: "୦",
	one: "୧",
	two: "୨",
	three: "୩",
	four: "୪",
	five: "୫",
	six: "୬",
	seven: "୭",
	eight: "୮",
	nine: "୯"
};
const numberData = {
	English: English$2,
	Hindi: Hindi$2,
	Marathi: Marathi$2,
	Gujarati: Gujarati$2,
	Punjabi: Punjabi$2,
	Bengali: Bengali$2,
	Tamil: Tamil$2,
	Telugu: Telugu$2,
	Kannada: Kannada$2,
	Assamese: Assamese$2,
	Malayalam: Malayalam$2,
	Oriya: Oriya$2
};

const English$1 = {
	Sunday: "S",
	Monday: "M",
	Tuesday: "T",
	Wednesday: "W",
	Thursday: "T",
	Friday: "F",
	Saturday: "S"
};
const Hindi$1 = {
	Sunday: "र",
	Monday: "सो",
	Tuesday: "मं",
	Wednesday: "बु",
	Thursday: "गु",
	Friday: "शु",
	Saturday: "श"
};
const Marathi$1 = {
	Sunday: "र",
	Monday: "सो",
	Tuesday: "मं",
	Wednesday: "बु",
	Thursday: "गु",
	Friday: "शु",
	Saturday: "श"
};
const Gujarati$1 = {
	Sunday: "ર",
	Monday: "સો",
	Tuesday: "મં",
	Wednesday: "બુ",
	Thursday: "ગુ",
	Friday: "શુ",
	Saturday: "શ"
};
const Punjabi$1 = {
	Sunday: "ਐ",
	Monday: "ਸੋ",
	Tuesday: "ਮੰ",
	Wednesday: "ਬੁ",
	Thursday: "ਵੀ",
	Friday: "ਸ਼ੁ",
	Saturday: "ਸ਼"
};
const Bengali$1 = {
	Sunday: "র",
	Monday: "সো",
	Tuesday: "মং",
	Wednesday: "বু",
	Thursday: "বৃ",
	Friday: "শু",
	Saturday: "শ"
};
const Tamil$1 = {
	Sunday: "ஞா",
	Monday: "தி",
	Tuesday: "செ",
	Wednesday: "பு",
	Thursday: "வி",
	Friday: "வெ",
	Saturday: "ச"
};
const Telugu$1 = {
	Sunday: "ఆ",
	Monday: "సో",
	Tuesday: "మం",
	Wednesday: "బు",
	Thursday: "గు",
	Friday: "శు",
	Saturday: "శ"
};
const Kannada$1 = {
	Sunday: "ಭಾ",
	Monday: "ಸೋ",
	Tuesday: "ಮಂ",
	Wednesday: "ಬು",
	Thursday: "ಗು",
	Friday: "ಶು",
	Saturday: "ಶ"
};
const Assamese$1 = {
	Sunday: "ৰ",
	Monday: "সো",
	Tuesday: "মং",
	Wednesday: "বু",
	Thursday: "বৃ",
	Friday: "শু",
	Saturday: "শ"
};
const Malayalam$1 = {
	Sunday: "ഞാ",
	Monday: "തി",
	Tuesday: "ചൊ",
	Wednesday: "ബു",
	Thursday: "വ്യ",
	Friday: "വെ",
	Saturday: "ശ"
};
const Oriya$1 = {
	Sunday: "ର",
	Monday: "ସୋ",
	Tuesday: "ମଂ",
	Wednesday: "ବୁ",
	Thursday: "ବି",
	Friday: "ଶୁ",
	Saturday: "ଶ"
};
const weekdayInitialsData = {
	English: English$1,
	Hindi: Hindi$1,
	Marathi: Marathi$1,
	Gujarati: Gujarati$1,
	Punjabi: Punjabi$1,
	Bengali: Bengali$1,
	Tamil: Tamil$1,
	Telugu: Telugu$1,
	Kannada: Kannada$1,
	Assamese: Assamese$1,
	Malayalam: Malayalam$1,
	Oriya: Oriya$1
};

const English = {
	Sunday: "Sunday",
	Monday: "Monday",
	Tuesday: "Tuesday",
	Wednesday: "Wednesday",
	Thursday: "Thursday",
	Friday: "Friday",
	Saturday: "Saturday"
};
const Hindi = {
	Sunday: "रविवार",
	Monday: "सोमवार",
	Tuesday: "मंगलवार",
	Wednesday: "बुधवार",
	Thursday: "गुरुवार",
	Friday: "शुक्रवार",
	Saturday: "शनिवार"
};
const Marathi = {
	Sunday: "रविवार",
	Monday: "सोमवार",
	Tuesday: "मंगळवार",
	Wednesday: "बुधवार",
	Thursday: "गुरुवार",
	Friday: "शुक्रवार",
	Saturday: "शनिवार"
};
const Gujarati = {
	Sunday: "રવિવાર",
	Monday: "સોમવાર",
	Tuesday: "મંગળવાર",
	Wednesday: "બુધવાર",
	Thursday: "ગુરુવાર",
	Friday: "શુક્રવાર",
	Saturday: "શનિવાર"
};
const Punjabi = {
	Sunday: "ਐਤਵਾਰ",
	Monday: "ਸੋਮਵਾਰ",
	Tuesday: "ਮੰਗਲਵਾਰ",
	Wednesday: "ਬੁੱਧਵਾਰ",
	Thursday: "ਵੀਰਵਾਰ",
	Friday: "ਸ਼ੁੱਕਰਵਾਰ",
	Saturday: "ਸ਼ਨਿਵਾਰ"
};
const Bengali = {
	Sunday: "রবিবার",
	Monday: "সোমবার",
	Tuesday: "মঙ্গলবার",
	Wednesday: "বুধবার",
	Thursday: "বৃহস্পতিবার",
	Friday: "শুক্রবার",
	Saturday: "শনিবার"
};
const Tamil = {
	Sunday: "ஞாயிறு",
	Monday: "திங்கள்",
	Tuesday: "செவ்வாய்",
	Wednesday: "புதன்",
	Thursday: "வியாழன்",
	Friday: "வெள்ளி",
	Saturday: "சனிக்கிழமை"
};
const Telugu = {
	Sunday: "ఆదివారం",
	Monday: "సోమవారం",
	Tuesday: "మంగళవారం",
	Wednesday: "బుధవారం",
	Thursday: "గురువారం",
	Friday: "శుక్రవారం",
	Saturday: "శనివారం"
};
const Kannada = {
	Sunday: "ಭಾನುವಾರ",
	Monday: "ಸೋಮವಾರ",
	Tuesday: "ಮಂಗಳವಾರ",
	Wednesday: "ಬುಧವಾರ",
	Thursday: "ಗುರುವಾರ",
	Friday: "ಶುಕ್ರವಾರ",
	Saturday: "ಶನಿವಾರ"
};
const Assamese = {
	Sunday: "ভানুৱার",
	Monday: "সোমবাৰ",
	Tuesday: "মঙ্গলবাৰ",
	Wednesday: "বুধবাৰ",
	Thursday: "বৃহস্পতিবাৰ",
	Friday: "শুক্ৰবাৰ",
	Saturday: "শনিবাৰ"
};
const Malayalam = {
	Sunday: "ഞായറാഴ്ച",
	Monday: "തിങ്കളാഴ്ച",
	Tuesday: "ചൊവ്വാഴ്ച",
	Wednesday: "ബുധനാഴ്ച",
	Thursday: "വ്യാഴാഴ്ച",
	Friday: "വെള്ളിയാഴ്ച",
	Saturday: "ശനിയാഴ്ച"
};
const Oriya = {
	Sunday: "ରବିବାର",
	Monday: "ସୋମବାର",
	Tuesday: "ମଙ୍ଗଳବାର",
	Wednesday: "ବୁଧବାର",
	Thursday: "ବୃହସ୍ପତିବାର",
	Friday: "ଶୁକ୍ରବାର",
	Saturday: "ଶନିବାର"
};
const weekdayNamesData = {
	English: English,
	Hindi: Hindi,
	Marathi: Marathi,
	Gujarati: Gujarati,
	Punjabi: Punjabi,
	Bengali: Bengali,
	Tamil: Tamil,
	Telugu: Telugu,
	Kannada: Kannada,
	Assamese: Assamese,
	Malayalam: Malayalam,
	Oriya: Oriya
};

const LOCALE_LANGUAGE_MAP = localeLanguageData;
const MONTH_DATES = monthDatesData;
const NUMBERS = numberData;
const WEEKDAY_INITIALS = weekdayInitialsData;
const WEEKDAY_NAMES = weekdayNamesData;
const MONTH_NAMES = monthNamesData;
const CONFIRM_BUTTON = confirmButtonData;
const OF = ofData;
const weekdayKeys = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];
const monthKeys = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthDateKeys = [
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
  "twenty_one",
  "twenty_two",
  "twenty_three",
  "twenty_four",
  "twenty_five",
  "twenty_six",
  "twenty_seven",
  "twenty_eight",
  "twenty_nine",
  "thirty",
  "thirty_one"
];
const numberKeys = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine"
];
function getLanguageFromLocale(locale) {
  return LOCALE_LANGUAGE_MAP[locale];
}
function getMonthDates(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const dates = MONTH_DATES[language];
  return monthDateKeys.map((key) => dates[key]);
}
function getMonthNames(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const names = MONTH_NAMES[language];
  return monthKeys.map((key) => names[key]);
}
function getNumbers(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const numbers = NUMBERS[language];
  return numberKeys.map((key) => numbers[key]);
}
function getWeekdayInitials(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const initials = WEEKDAY_INITIALS[language];
  return weekdayKeys.map((key) => initials[key]);
}
function getWeekdayNames(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const names = WEEKDAY_NAMES[language];
  return weekdayKeys.map((key) => names[key]);
}
function getConfirmLabel(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const labelObj = CONFIRM_BUTTON[language];
  return Object.values(labelObj)[0];
}
function getOf(locale = "en") {
  const language = getLanguageFromLocale(locale);
  const ofObj = OF[language];
  return Object.values(ofObj)[0];
}

export { TokenContext, TokenProvider, createComponent, getConfirmLabel, getCustomJSON, getLanguageFromLocale, getMonthDates, getMonthNames, getNumbers, getOf, getWeekdayInitials, getWeekdayNames, registerIcons, useIcons, useToken, useTokenValues };
